/* ═══════════════════════════════════════════════════════════════════════
   Icons, drawn rather than typed.

   An emoji is somebody else's artwork: it renders as a cartoon on one
   platform, a flat glyph on another, a box on a third, and it never takes
   the colour of the text around it. Fine in a customer's own message,
   wrong in the furniture of a form somebody is trusting with a password.

   These are strokes on a 20-unit grid using `currentColor`, so they
   inherit the colour and the theme of whatever they sit in, stay crisp at
   any size, and look the same to everybody.
   ═══════════════════════════════════════════════════════════════════════ */

const base = {
  viewBox: "0 0 20 20",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

/** An open eye. The password is showing. */
export function EyeOpen({ size = 18 }: { size?: number }) {
  return (
    <svg {...base} width={size} height={size}>
      <path d="M1.6 10S4.7 4.8 10 4.8 18.4 10 18.4 10 15.3 15.2 10 15.2 1.6 10 1.6 10Z" />
      <circle cx="10" cy="10" r="2.4" />
    </svg>
  );
}

/**
 * A closed eye. The password is hidden.
 *
 * A lid and lashes rather than the more common eye-with-a-slash. The slash
 * reads as "forbidden" as often as "hidden", and this button is not
 * refusing anybody anything — it is simply the other half of a toggle.
 */
export function EyeClosed({ size = 18 }: { size?: number }) {
  return (
    <svg {...base} width={size} height={size}>
      <path d="M1.6 8.4S4.7 12.9 10 12.9s8.4-4.5 8.4-4.5" />
      <path d="M3.9 11.6 2.5 13.6" />
      <path d="M7.3 13 6.7 15.2" />
      <path d="M12.7 13l.6 2.2" />
      <path d="M16.1 11.6l1.4 2" />
    </svg>
  );
}
